import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import comparisonService from "../../api/comparisonService";

export const compare = createAsyncThunk(
  "comparison/compare",
  async (payload) => {
    try {
      const response = await comparisonService.compare(payload);

      if (response) {
        return {
          comparisonItem: response?.data,
          actionFlag: "COMP_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        comparisonItem: [],
        actionFlag: "COMP_ERR",
        success: "",
        error: error,
      };
    }
  },
);
export const publicCompare = createAsyncThunk(
  "comparison/publicCompare",
  async (payload) => {
    try {
      const response = await comparisonService.publicCompare(payload);

      if (response) {
        return {
          publicComparisonItem: response?.data,
          actionFlag: "PUB_COMP_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        publcComparisonItem: [],
        actionFlag: "PUB_COMP_ERR",
        success: "",
        error: error,
      };
    }
  },
);

export const compareDashboard = createAsyncThunk(
  "comparison/compareDashboard",
  async (payload) => {
    try {
      const response = await comparisonService.compare(payload);
      if (response) {
        return {
          comparisonItem: response?.data,
          actionFlag: "COMP_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        comparisonItem: [],
        actionFlag: "COMP_ERR",
        success: "",
        error: error,
      };
    }
  },
);

export const filterCity = createAsyncThunk(
  "comparison/filterCity",
  async (payload) => {
    try {
      const response = await comparisonService.filter(payload);
      if (response) {
        return {
          filterItems: response?.data,
          actionFlag: "FILTER_ITEMS_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        filterItems: {},
        actionFlag: "FILTER_ITEMS_ERR",
        success: "",
        error: error,
      };
    }
  },
);

export const checkComparisionCityCount = createAsyncThunk(
  "comparison/checkComparisionCityCount",
  async (payload) => {
    try {
      const response = await comparisonService.comapreCityCount(payload);
      const { status, data } = response;
      return {
        success: status === 200,
        message: data?.message,
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message,
      };
    }
  },
);

export const getCompareCityData = createAsyncThunk(
  "comparison/getCompareCityData",
  async (payload) => {
    try {
      const response = await comparisonService.CompareCity(payload);
      if (response) {
        return {
          compareCityItems: response?.data,
          actionFlag: "COMPARE_CITY_ITEMS_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        compareCityItems: {},
        actionFlag: "COMPARE_CITY_ITEMS_ERR",
        success: "",
        error: error,
      };
    }
  },
);
export const getCompareCityCountData = createAsyncThunk(
  "comparison/getCompareCityCountData",
  async (payload) => {
    try {
      const response = await comparisonService.CompareCityOnly(payload);
      if (response) {
        return {
          compareCityCountItems: response?.data,
          actionFlag: "COMPARE_CITY_COUNT_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        compareCityCountItems: {},
        actionFlag: "COMPARE_CITY_COUNT_ERR",
        success: "",
        error: error,
      };
    }
  },
);

export const UpdateInCompareCity = createAsyncThunk(
  "comparison/UpdateInCompareCity",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await comparisonService.UpdateUser(payload);

      return {
        UpdateCompareCityItems: response?.data?.data,
        message: response?.data?.message,
        success: response?.data?.success,
        actionFlag: "UPDATE_COMPARE_CITY_ITEMS_SCS",
      };
    } catch (error) {
      return rejectWithValue({
        message: error?.response?.data?.message || "Failed to remove city",
        actionFlag: "UPDATE_COMPARE_CITY_ITEMS_ERR",
      });
    }
  },
);

export const getUserCityData = createAsyncThunk(
  "comparison/getUserCityData",
  async () => {
    try {
      const response = await comparisonService.userCity();
      if (response) {
        return {
          userCityItems: response?.data,
          actionFlag: "USER_CITY_ITEMS_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        userCityItems: {},
        actionFlag: "USER_CITY_ITEMS_ERR",
        success: "",
        error: error,
      };
    }
  },
);

export const getHospitalData = createAsyncThunk(
  "comparison/getHospitalData",
  async (params) => {
    try {
      const response = await comparisonService.hospitalInfo(params);
      if (response) {
        return {
          hospitalItems: response?.data,
          actionFlag: "HOSPITAL_INFO_ITEMS_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        hospitalItems: {},
        actionFlag: "HOSPITAL_INFO_ITEMS_ERR",
        success: "",
        error: error,
      };
    }
  },
);

// Public (no-auth) counterpart of getHospitalData for guests viewing a
// shared job-detail link — writes to the same `hospitalItems` state slot,
// so components that read it don't need to know which one fired.
export const getHospitalDataPublic = createAsyncThunk(
  "comparison/getHospitalDataPublic",
  async (params) => {
    try {
      const response = await comparisonService.hospitalInfoPublic(params);
      if (response) {
        return {
          hospitalItems: response?.data,
          actionFlag: "HOSPITAL_INFO_PUBLIC_ITEMS_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        hospitalItems: {},
        actionFlag: "HOSPITAL_INFO_PUBLIC_ITEMS_ERR",
        success: "",
        error: error,
      };
    }
  },
);

export const getHospitalCountData = createAsyncThunk(
  "comparison/getHospitalCountData",
  async (params) => {
    try {
      const response = await comparisonService.hospitalInfoCount(params);
      if (response) {
        return {
          hospitalCountItems: response?.data,
          actionFlag: "HOSPITAL_INFO_COUNT_SCS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      return {
        hospitalCountItems: {},
        actionFlag: "HOSPITAL_INFO_COUNT_ERR",
        success: "",
        error: error,
      };
    }
  },
);

export const updateSalaryAndHousing = createAsyncThunk(
  "comparison/updateSalaryAndHousing",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await comparisonService.changeSalary(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error);
    }
  },
);
export const mapAnalytics = createAsyncThunk(
  "/comparison/mapAnalytics",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await comparisonService.mapAnalytics(payload);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

//  Initial state
const initialState = {
  profileItem: {},
  comparisonItem: {},
  publicComparisonItem: {},
  experienceItems: {},
  UpdateCompareCityItems: {},
  cityItems: {},
  hospitalItems: {},
  hospitalCountItems: {},
  userCityItems: {},
  filterItems: {},
  stateItems: {},
  roleItems: {},
  compareCityItems: {},
  compareCityCountItems: {},
  actionFlag: "",
  locationChoiceItems: {},
  mapAnalyticsItems: {},
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

//  Slice definition
const comparisonSlice = createSlice({
  name: "comparison",
  initialState,
  reducers: {
    // Reset state
    resetContactState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
      state.successMessage = "";
      state.actionFlag = "";
    },
    // Clear messages
    clearMessages: (state) => {
      state.successMessage = "";
      state.errorMessage = "";
      state.actionFlag = "";
    },
  },
  extraReducers: (builder) => {
    // User Signup
    builder
      .addCase(compare.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(compare.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.comparisonItem = action.payload.comparisonItem || [];
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(compare.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(publicCompare.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(publicCompare.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.publicComparisonItem = action.payload.publicComparisonItem || [];
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(publicCompare.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(compareDashboard.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(compareDashboard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.comparisonItem = action.payload.comparisonItem || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(compareDashboard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(filterCity.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(filterCity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.filterItems = action.payload.filterItems || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(filterCity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(checkComparisionCityCount.pending, (state) => {
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(checkComparisionCityCount.fulfilled, (state, action) => {
        state.isSuccess = true;
        state.successMessage =
          action.payload.success || "Message sent successfully!";
        state.errorMessage = "";
      })
      .addCase(checkComparisionCityCount.rejected, (state, action) => {
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getCompareCityData.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(getCompareCityData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.compareCityItems = action.payload.compareCityItems || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(getCompareCityData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getCompareCityCountData.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(getCompareCityCountData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.compareCityCountItems =
          action.payload.compareCityCountItems || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(getCompareCityCountData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(UpdateInCompareCity.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(UpdateInCompareCity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.UpdateCompareCityItems =
          action.payload.UpdateCompareCityItems || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(UpdateInCompareCity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getUserCityData.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(getUserCityData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.userCityItems = action.payload.userCityItems || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(getUserCityData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getHospitalData.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(getHospitalData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.hospitalItems = action.payload.hospitalItems || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(getHospitalData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getHospitalDataPublic.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(getHospitalDataPublic.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.hospitalItems = action.payload.hospitalItems || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(getHospitalDataPublic.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getHospitalCountData.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(getHospitalCountData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.hospitalCountItems = action.payload.hospitalCountItems || {};
        state.errorMessage = "";
        state.actionFlag = action.payload.actionFlag;
      })
      .addCase(getHospitalCountData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(updateSalaryAndHousing.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(updateSalaryAndHousing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage = "Updated successfully!";
        const current = state.userCityItems?.data?.city_details || {};
        state.userCityItems.data.city_details = {
          ...current,
          median_annual_salary:
            action.meta.arg.median_annual_salary ??
            current.median_annual_salary,
          yearly_average_cost_of_owning_and_renting:
            action.meta.arg.annual_mortgage_payment_or_rent ??
            current.yearly_average_cost_of_owning_and_renting,
        };

        state.actionFlag = "SALARY_HOUSING_UPDATED";
      })
      .addCase(updateSalaryAndHousing.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;

        const errorData = action.payload;

        let errorMessage = "Update failed";

        if (errorData?.data?.message) {
          errorMessage = errorData.data.message;
        } else if (errorData?.message) {
          errorMessage = errorData.message;
        }

        state.errorMessage = errorMessage
          .replace(/^"|"$/g, "")
          .replace(/\\"/g, '"');
        state.actionFlag = "SALARY_HOUSING_ERROR";
      })
      .addCase(mapAnalytics.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(mapAnalytics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.mapAnalyticsItems = action.payload || "";
      })
      .addCase(mapAnalytics.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

export const { resetContactState, clearMessages } = comparisonSlice.actions;
export default comparisonSlice.reducer;
